module.exports = __webpack_public_path__ + "assets/8aa33e10cb50c96214a09eefe84c3a33.png";